module.exports = __webpack_public_path__ + "static/media/cold11.32e7748a.jpg";